import React from "react";
import { Box, Chip, TextField, MenuItem } from "@mui/material";
import { filterOptions, sortOptions } from "./ViewFeedback";
import { SearchRounded } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  filterChip: {
    color: theme.palette.text.secondary,
  },
  activeFilterChip: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.selection,
  },
}));

function Filters({ tab, onTabChange, query, onQueryChange, sort, onSortChange }) {
  return (
    <Box
      p={3}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}>
      <FilterChips tab={tab} onTabChange={onTabChange} />
      <Box display="flex" alignItems="center" gap={2}>
        <Search query={query} onQueryChange={onQueryChange} />
        <Sort sort={sort} onSortChange={onSortChange} />
      </Box>
    </Box>
  );
}

function FilterChips({ tab, onTabChange }) {
  const { classes } = useStyles();
  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      {filterOptions.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          onClick={() => onTabChange(option.value)}
          className={
            tab === option.value ? classes.activeFilterChip : classes.filterChip
          }
        />
      ))}
    </Box>
  );
}

function Search({ query, onQueryChange }) {
  return (
    <TextField
      value={query}
      onChange={onQueryChange}
      size="small"
      placeholder="Search across feedbacks"
      InputProps={{
        startAdornment: (
          <SearchRounded
            sx={{ mr: 1, color: (theme) => theme.palette.action.active }}
          />
        ),
        style: { borderRadius: 8, minWidth: 350 },
      }}
    />
  );
}

function Sort({ sort, onSortChange }) {
  return (
    <TextField
      select
      value={sort}
      onChange={onSortChange}
      InputProps={{
        style: { borderRadius: 8 },
      }}
      variant="outlined"
      label="Sort By"
      size="small"
      sx={{ minWidth: 170 }}>
      {sortOptions.map((option) => {
        const { value, label } = option;
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </TextField>
  );
}

export default Filters;
